import React from 'react';

/** Official WhatsApp glyph (Meta brand mark) — drawn as a single-path SVG so it
 *  inherits `currentColor` and scales cleanly inside chips/buttons. */
const WhatsAppIcon = ({ className = '', size }) => (
  <svg
    viewBox="0 0 24 24"
    width={size}
    height={size}
    className={className}
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M17.47 14.38c-.3-.15-1.78-.88-2.05-.98-.27-.1-.47-.15-.67.15-.2.3-.77.97-.95 1.17-.17.2-.35.22-.65.07-.3-.15-1.27-.47-2.42-1.5-.9-.8-1.5-1.78-1.67-2.08-.18-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.18.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51l-.57-.01c-.2 0-.52.07-.8.37-.27.3-1.05 1.02-1.05 2.5 0 1.47 1.07 2.9 1.22 3.1.15.2 2.1 3.21 5.1 4.5.71.31 1.27.49 1.7.63.71.23 1.36.2 1.87.12.57-.08 1.78-.72 2.03-1.42.25-.7.25-1.3.18-1.42-.07-.12-.27-.2-.57-.35zM12.04 21.5c-1.66 0-3.27-.45-4.69-1.3l-.34-.2-3.49.91.93-3.4-.22-.35a8.73 8.73 0 0 1-1.34-4.66c0-4.83 3.93-8.76 8.76-8.76 2.34 0 4.54.91 6.19 2.57a8.7 8.7 0 0 1 2.57 6.19c0 4.83-3.93 8.76-8.76 8.76zm7.45-16.21A10.46 10.46 0 0 0 12.04 2C6.27 2 1.58 6.69 1.58 12.46c0 1.84.48 3.64 1.4 5.23L1.5 22l4.41-1.16a10.43 10.43 0 0 0 5 1.27h.01c5.77 0 10.46-4.69 10.46-10.46 0-2.79-1.09-5.42-3.07-7.36z" />
  </svg>
);

export default WhatsAppIcon;
